import { safecheckEn } from "./safecheck/en";

export const en: Translations = {
  nav: {
    dashboards: "Dashboards",
    ecommerce: "eCommerce",
    analytics: "Analytics",
    crm: "CRM",
    landing: "Landingpage",
  },
  header: {
    menu: "Menu",
    closeSidebar: "Collapse menu",
    grid: "Grid",
    search: "Search",
    messages: "Messages",
    notifications: "Notifications",
    language: "Change language",
    settings: "Settings",
    profile: "Profile",
    logout: "Log out",
    changeSession: "Change session",
    sessionActive: "Active session",
    userNames: {
      admin: "Elvis KATUALA",
      auditor: "Guystave MONYAWANGERE",
    },
  },
  shell: {
    emergencyHelp: "Emergency help",
    promoTitle: "Make an appointment",
    promoSubtitle: "Best health care here",
    promoCta: "Learn more",
    fullscreen: "Fullscreen",
  },
  search: {
    placeholder: "Search a page or action...",
    noResults: "No Safecheck results",
    pages: "Page",
    widgets: "Shortcut",
    actions: "Action",
    indicators: "Indicator",
    shortcut: "⌘K",
  },
  settings: {
    title: "Settings",
    appearance: "Appearance",
    theme: "Choose your theme",
    themeLight: "Light",
    themeDark: "Dark",
    themeSystem: "System",
    language: "Language",
    languageDescription: "Select your preferred language",
    layout: "Layout",
    sidebarExpanded: "Expanded sidebar",
    close: "Close settings",
  },
  safecheck: safecheckEn,
  actions: {
    saved: "Saved successfully.",
    exported: "Export completed.",
    deleted: "Deleted successfully.",
    printed: "Print started.",
  },
  common: {
    orders: "Orders",
    expenses: "Expenses",
    clicks: "clicks",
    winner: "Winner",
    visitors: "Visitors",
    conversions: "Conversions",
    bounce: "Bounce",
    sales: "sales",
    options: "Options",
    order: "Order",
    customer: "Customer",
    product: "Product",
    amount: "Amount",
    status: "Status",
    balance: "Balance",
    cardNumber: "Card Number",
    lastMonth: "last month",
    last12Months: "last 12 months",
    january: "January",
    completed: "Completed",
    pending: "Pending",
    shipped: "Shipped",
    devices: { Desktop: "Desktop", Mobile: "Mobile", Tablet: "Tablet" },
    months: {
      Jan: "Jan", Feb: "Feb", Mar: "Mar", Apr: "Apr", May: "May", Jun: "Jun", July: "July",
      JAN: "JAN", FEB: "FEB", MAR: "MAR", APR: "APR", MAY: "MAY", JUN: "JUN",
      W1: "W1", W2: "W2", W3: "W3", W4: "W4", W5: "W5", W6: "W6",
      Mon: "Mon", Tue: "Tue", Wed: "Wed", Thu: "Thu", Fri: "Fri", Sat: "Sat", Sun: "Sun",
    },
    categories: {
      Electronics: "Electronics",
      Accessories: "Accessories",
      Clothing: "Clothing",
      Other: "Other",
    },
    sources: {
      Organic: "Organic",
      Direct: "Direct",
      Social: "Social",
      Referral: "Referral",
    },
  },
  crm: {
    pageTitle: "CRM Dashboard",
    pageDescription: "Customer relationship management overview",
    overallBalance: "Overall Balance",
    trend: "+16.3% last 12 months",
    totalSales: "Total Sales",
    totalProfit: "Total Profit",
    totalUsers: "Total Users",
    totalExpense: "Total Expense",
    roi: "Return On Investment",
    roiValue: "283% ROI",
    monthlyChange: "+24% January",
    totalFollowers: "Total Followers",
    totalIncome: "Total Income",
    currentBalance: "Current Balance",
    changeFollowers: "+23% last month",
    changeIncome: "+18% last month",
    changeBalance: "+42% last month",
    marketingReport: "Marketing Report",
    searchVolume: "Search Volume",
    returnRatio: "Return Ratio",
    paymentMethods: "Payment Methods",
  },
  ecommerce: {
    pageTitle: "eCommerce Dashboard",
    pageDescription: "Sales, products and orders overview",
    revenueOverview: "Revenue Overview",
    topProducts: "Top Products",
    salesByCategory: "Sales by Category",
    recentOrders: "Recent Orders",
    stats: {
      orders: "Total Orders",
      revenue: "Revenue",
      customers: "Customers",
      returns: "Returns",
    },
  },
  analytics: {
    pageTitle: "Analytics Dashboard",
    pageDescription: "Website traffic and user behavior insights",
    trafficOverview: "Traffic Overview",
    trafficSources: "Traffic Sources",
    topPages: "Top Pages",
    deviceBreakdown: "Device Breakdown",
    stats: {
      visitors: "Visitors",
      pageviews: "Page Views",
      bounce: "Bounce Rate",
      duration: "Avg. Duration",
    },
  },
  landing: {
    pageTitle: "Landingpage Dashboard",
    pageDescription: "Landing page performance and conversion tracking",
    signupsConversions: "Signups & Conversions",
    ctaPerformance: "CTA Performance",
    abTestResults: "A/B Test Results",
    stats: {
      visitors: "Landing Visitors",
      signups: "Sign Ups",
      conversion: "Conversion Rate",
      cta: "CTA Clicks",
    },
    ctas: {
      getStarted: "Get Started Free",
      watchDemo: "Watch Demo",
      contactSales: "Contact Sales",
      downloadPdf: "Download PDF",
    },
    variants: {
      variantA: "Variant A — Blue CTA",
      variantB: "Variant B — Green CTA",
    },
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark all as read",
    clearAll: "Clear all",
    empty: "No notifications",
    delete: "Delete notification",
    justNow: "Just now",
    minutesAgo: "{{n}} min ago",
    hoursAgo: "{{n}}h ago",
    yesterday: "Yesterday",
    items: {
      newAdmission: {
        title: "New admission",
        message: "Patient Mwamba K. admitted at Medecin de nuit hospital — CEEC",
      },
      invoicesPendingReview: {
        title: "Invoices pending review",
        message: "3 submitted invoices require validation (FAC-2026-022, 021, 020)",
      },
      urgentAuthorization: {
        title: "Urgent authorization",
        message: "Request #1247 — cardiac surgery, high priority",
      },
      invoiceApproved: {
        title: "Invoice approved",
        message: "FAC-2026-019 validated for Medecin de nuit — $15,600",
      },
      conventionExpiring: {
        title: "Convention expiring",
        message: "Convention CONV-03 with CEEC expires in 15 days",
      },
      newProviderRegistered: {
        title: "New provider",
        message: "Mwangeji Clinic registered in the Safecheck network",
      },
      systemBackupComplete: {
        title: "Backup completed",
        message: "Automatic system backup completed successfully",
      },
      newEmployeeRegistered: {
        title: "New employee",
        message: "Katanga M. added as beneficiary — CEEC company",
      },
    },
  },
};
